import PortalVue from "portal-vue";
Vue.use(PortalVue);
import Vue from 'vue'
import vselect from "vue-select";

import 'lazysizes';

require('./scoopOS');

Vue.filter('formatBytes', (bytes, decimalCount = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimalCount < 0 ? 0 : decimalCount;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});

Vue.component('v-select', vselect);

Vue.component('TablePagerSimple', require('./components/TablePagerSimple').default);
Vue.component('TablePager', require('./components/TablePager').default);
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.component('tree-node', require('./components/TreeNode').default);
Vue.component('Lightbox', require('./components/Lightbox').default);
Vue.component('field-value-editor', require('./components/FieldValueEditor').default);
Vue.component('interactive-select', require('./components/InteractiveSelect').default);
Vue.component('interactive-select-multiple', require('./components/InteractiveSelectMultiple').default);
Vue.component('edit-tags', require('./components/EditTags').default);
Vue.component('global-search-bar', require('./components/GlobalSearchBar').default);
Vue.component('global-search-bar-info', require('./components/GlobalSearchBarInfo').default);
Vue.component('media-file', require('./components/MediaFile').default);
Vue.component('media-preview', require('./components/MediaPreview').default);
Vue.component('media-rename', require('./components/MediaRename').default);
Vue.component('media-direct-download', require('./components/MediaDirectDownload').default);
Vue.component('media-filters', require('./components/MediaFilters').default);
Vue.component('files-upload', require('./components/FilesUpload').default);
Vue.component('media-upload', require('./components/MediaUpload').default);
Vue.component('media-upload-v2', require('./components/MediaUploadV2').default);
Vue.component('media-upload-status', require('./components/MediaUploadStatus').default);
Vue.component('media-directories', require('./components/MediaDirectories').default);
Vue.component('media-move', require('./components/MediaMove').default);
Vue.component('media-icon-failed-validations', require('./components/MediaIconFailedValidations').default);
Vue.component('video-player', require('./components/VideoPlayer').default);
Vue.component('tooltip', require('./components/Tooltip').default);

// Global Layout Icons
Vue.component('global-layout-icon-download-media', require('./components/global-layout-icons/DownloadMediaIcon').default);
Vue.component('global-layout-icon-move-media', require('./components/global-layout-icons/MoveMediaIcon').default);
Vue.component('global-layout-icon-queue-status', require('./components/global-layout-icons/QueueStatusWidget').default);
Vue.component('global-layout-icon-selected-attribute-value-widget', require('./components/global-layout-icons/SelectedAttributeValueWidget').default);
Vue.component('global-layout-icon-logout', require('./components/global-layout-icons/LogoutIcon').default);

// @deprecated
Vue.component('selected-media-widget', require('./components/navigation-widgets/SelectedMediaWidget').default);

Vue.component('combine-correct-attribute-values', require('./components/attributes/CombineCorrectAttributeValues').default);
Vue.component('text-attribute-dropdown', require('./components/TextAttributeDropdown').default);
Vue.component('text-attribute-dropdown-with-quantity-share', require('./components/TextAttributeDropdownWithQuantityShare').default);
Vue.component('text-attribute-dropdown-with-dimensions', require('./components/TextAttributeDropdownWithDimensions').default);
Vue.component('text-attribute-input', require('./components/TextAttributeInput').default);
Vue.component('text-attribute-license', require('./components/TextAttributeLicense').default);

Vue.component('text-attribute-yes-no', require('./components/TextAttributeYesNo').default);
Vue.component('text-attribute-for-element', require('./components/TextAttributeForElement').default);
Vue.component('MultilangField', require('./components/MultilangField').default);

Vue.component('filter-area', require('./components/filters/FilterArea').default);
Vue.component('filter-element-button-group', require('./components/filters/FilterElementButtonGroup').default);
Vue.component('filter-element-checkbox', require('./components/filters/FilterElementCheckbox').default);
Vue.component('filter-element-text', require('./components/filters/FilterElementText').default);
Vue.component('filter-element-text-in-language', require('./components/filters/FilterElementTextInLanguage').default);

Vue.component('model-picker', require('./components/ModelPicker').default);
Vue.component('user-policy-generator', require('./components/UserPolicyGenerator').default);

Vue.component('packages', require('../../Packages/resources/js/components/Packages').default);
Vue.component('media-package', require('../../Packages/resources/js/components/MediaPackage').default);

Vue.component('pr-filter-dropdown', require('../../Pr/resources/js/components/PrFilterDropdown').default);

Vue.component('upload-filter', require('../../ModelSelector/resources/js/components/UploadFilter').default);

Vue.component('found-media-index-filename', require('../../ModelSelector/resources/js/components/FoundMediaIndexFilename').default);
Vue.component('found-media-tag', require('../../ModelSelector/resources/js/components/FoundMediaTag').default);
Vue.component('found-media-id', require('../../ModelSelector/resources/js/components/FoundMediaId').default);
Vue.component('missing-media-index-filename', require('../../ModelSelector/resources/js/components/MissingMediaIndexFilename').default);
Vue.component('missing-media-tag', require('../../ModelSelector/resources/js/components/MissingMediaTag').default);
Vue.component('missing-media-id', require('../../ModelSelector/resources/js/components/MissingMediaId').default);

Vue.component('add-media-to-pressdatabase', require('../../Pr/resources/js/components/AddMediaToPressdatabase').default);

Vue.component('total-user-count', require('../js/components/stats/TotalUserCount').default);
Vue.component('stats-active-users', require('../js/components/stats/ActiveUsers').default);
Vue.component('stats-active-users-development', require('../js/components/stats/ActiveUsersDevelopment').default);
Vue.component('user-detail-statistics', require('../js/components/stats/UserDetailStatistics').default);
Vue.component('disk-usage', require('../js/components/stats/DiskUsage').default);

Vue.component('editable-select', require('./components/editable-fields/EditableSelect').default);
Vue.component('editable-text', require('./components/editable-fields/EditableText').default);
Vue.component('editable-date', require('./components/editable-fields/EditableDate').default);

Vue.component('category-selector', require('./components/categories/CategorySelector').default);

Vue.component('text-field-multilanguage', require('./components/translation/TextFieldMultilanguage').default);

Vue.component('media-of-index-selection-dialog', require('../../Packages/resources/js/components/MediaOfIndexSelectionDialog').default);
Vue.component('multi-lang-text-input', require('./components/MultiLangTextInput').default);

//V1 Publishing NewFacets
Vue.component('headline', require('./components/Headline').default);
Vue.component('FacetFilter', require('./components/media-facets/FacetFilter').default);
Vue.component('MediaFacet', require('./components/media-facets/MediaFacet').default);
Vue.component('OrderBy', require('./components/media-facets/OrderBy').default);
Vue.component('FacetCollapse', require('./components/media-facets/FacetCollapse').default);
//end V1 Publishing NewFacets
